module.exports = __webpack_public_path__ + "static/img/chanping3.36b4da9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp1/chanping3.jpg
// module id = Ee6j
// module chunks = 0